import { render, staticRenderFns } from "./UpdateModule.html?vue&type=template&id=64cbf4da&scoped=true&"
import script from "./UpdateModule.vue?vue&type=script&lang=js&"
export * from "./UpdateModule.vue?vue&type=script&lang=js&"
import style0 from "./UpdateModule.vue?vue&type=style&index=0&id=64cbf4da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cbf4da",
  null
  
)

export default component.exports